import { TReduxActions } from '../../../types/redux';
import { FILTERS_SELECT_OFFER_TYPE_TYPE } from '../../../constants/action_types';
import { IJsonQuery, JsonQuery } from '../../../utils/jsonQuery';
import { defaultState } from './defaultState';

export function selectOfferTypeReducer(jsonQuery: IJsonQuery = defaultState, action: TReduxActions): IJsonQuery {
  switch (action.type) {
    case FILTERS_SELECT_OFFER_TYPE_TYPE:
      return new JsonQuery(jsonQuery).selectOfferType(action.offerType).getSerializable();
  }

  return jsonQuery;
}
